import { z } from 'zod';
export const HealthSchema = z.object({
    status: z.literal('ok'),
    timestamp: z.string().datetime(),
    service: z.string(),
});
export function buildHealth(service) {
    return {
        status: 'ok',
        timestamp: new Date().toISOString(),
        service,
    };
}
export * from './ids.js';
export * from './identity.js';
export * from './webhooks.js';
export * from './email.js';
export * from './connector.js';
export * from './contacts.js';
export * from './templates.js';
export * from './events.js';
export * from './campaigns.js';
export * from './customer-config.js';
export * from './permissions.js';
export * from './event-state.js';
export * from './kite-pages.js';
export * from './service-profiles.js';
export * from './tts-voices.js';
export * from './booking.js';
export * from './pbx-adapter.js';
export * from './pbx-api-keys.js';
export * from './timezones.js';
export * from './training.js';
//# sourceMappingURL=index.js.map